<template>
	<div>
		<RouterView />
	</div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { RouterView } from "vue-router";
import { useMainStore } from "./store/mainStore";

const store = useMainStore();

onMounted(() => {
	// Checking if device is a touchscreen.
	// Using "any-pointer" instead of "pointer" because "pointer"
	// makes the decision based on the PRIMARY input device, while
	// "any-pointer" checks if ANY input device is touchscreen.
	if (window.matchMedia("(any-pointer: coarse)").matches) {
		store.isTouchscreen = true;
	}
});
</script>
